/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { LanguageService } from '../services';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myLbTranslate',
    pure: false,
})

export class LanguagePipe implements PipeTransform {

    constructor(
        private languageService: LanguageService
    ) {
    }

    /**
     *
     * @param {string} value
     * @param placeholder
     * @returns {any}
     */
    public transform(value: string, placeholder?: string | number | any[]): any {
        if (!value) {
            return '';
        }

        return value === value.toLowerCase() ? this.languageService.translate(value, placeholder) : value;
    }
}
